import { Button, H3, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Text } from 'vet-bones/components';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { generateDateTimeId, generateRandomId } from 'src/utils/generateId';
import { stopPropagation } from 'src/utils/handlers/stopPropagation';
import { useNavigateProject } from 'src/utils/hooks/useNavigateProject';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

export const HomeVoiceboxIntro = () => {
  const dispatch = useReduxDispatch();
  const navigateProject = useNavigateProject();

  const onButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      stopPropagation(event);
      const name = `Voicebox-${generateRandomId()}`;
      const id = generateDateTimeId();
      const dateCreated = Date.now();

      dispatch(
        projectsActionCreators.addedProject({
          id,
          name,
          dateCreated,
        })
      );
      dispatch(
        uiSlice.actions.toggledVoiceboxDialog({
          isPendingOpen: true,
        })
      );
      navigateProject(id);
    },
    [dispatch, navigateProject]
  );

  return (
    <div className="sd-home-voicebox-intro">
      <div className="sd-home-voicebox-intro__body">
        <H3>
          {copy.components.home.voicebox.headerFirst}
          <br />
          {copy.components.home.voicebox.headerSecond}
        </H3>
        <Text>{copy.components.home.voicebox.body}</Text>
        <Button
          intent={Intent.PRIMARY}
          onClick={onButtonClick}
          text={copy.components.home.voicebox.button}
        />
      </div>
    </div>
  );
};
